/**
 * Extracts the destinationID code from a URL containing "/shared/dXX_...".
 *
 * @param {string} urlString The URL to extract the code from.
 * @returns {string|null} The destinationID code, or null if not found or on error.
 */
export const getDestinationIdFromSharedSearchUrl = urlString => {
  try {
    const url = new URL(urlString)
    const pathname = url.pathname
    const parts = pathname.split('/')
    const sharedIndex = parts.indexOf('shared')

    if (sharedIndex !== -1 && sharedIndex + 1 < parts.length) {
      const lastPart = parts[sharedIndex + 1]
      const destinationId = lastPart.split('_')[0]
      return destinationId
    }
    return null
  } catch (error) {
    console.error('Error processing URL:', error)
    return null
  }
}
